import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

import useDisplay from "../../../hooks/useDisplay";
import LSRgBody02 from "../../molecules/text/linSeedKr/Rg/lsRgBody02";
import LSBdDisplay02 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay02";
import TermApi from "../../../api/term.api";
import { errorHandler } from "../../../util/errorHandler";

function TermModal({
  visiable,
  setVisiable,
  isScroll,
  termCategory,
  isDetail,
}) {
  const { isMobile, isTablet, isDesktop } = useDisplay();

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  useEffect(() => {
    if (!isScroll) {
      document.body.style.cssText = `
      position: fixed; 
      top: -${window.scrollY}px;
      overflow-y: hidden;
      width: 99%;`;
      return () => {
        const scrollY = document.body.style.top;
        document.body.style.cssText = "";
        window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
      };
    }
  }, [isScroll]);

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (termCategory) {
      getTermInfo(termCategory);
    }
  }, [termCategory]); // eslint-disable-line react-hooks/exhaustive-deps

  const getTermInfo = async (termCategory) => {
    try {
      const response = (await TermApi.getDetail(termCategory)).data.data
        .content;
      setContent(response.content);
      setTitle(response.title);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <TermModalWrapper $isMobile={isMobile}>
      <TermModalContainer $isMobile={isMobile}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              position: "relative",
              marginBottom: 22,
            }}
          >
            <img
              onClick={() => {
                setVisiable(false);
              }}
              style={{
                width: 18,
                height: 18,
                cursor: "pointer",
                position: "absolute",
                right: 0,
              }}
              src={"/assets/icons/close.png"}
              alt="close"
            />
          </div>

          <div
            style={{
              width: "100%",
              height: 700,
              paddingBottom: 60,
            }}
          >
            <LSBdDisplay02
              style={{
                color: "#000000",
                marginBottom: 30,
                fontSize: isMobile ? 16 : 24,
                lineHeight: isMobile ? "22.4px" : "33.6px",
              }}
            >
              {title}
            </LSBdDisplay02>
            <LSRgBody02
              className="ql-editor"
              style={{
                color: "#404249",
                fontSize: isMobile ? 12 : 15,
                lineHeight: isMobile ? "14.4px" : "21px",
              }}
              dangerouslySetInnerHTML={{
                __html: content,
              }}
            />
          </div>
        </div>
      </TermModalContainer>
    </TermModalWrapper>
  );
}

export default TermModal;

// 페이드인 효과 정의
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const TermModalWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 70px 0; */
  padding: ${(props) => (props.$isMobile ? "0px 20px" : "70px 0px")};
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  z-index: 1000;
`;

const TermModalContainer = styled.div`
  width: ${(props) => (props.$isMobile ? "100%" : "996px")};
  padding: ${(props) =>
    props.$isMobile ? "40px 20px" : "40px 40px 40px 60px"};
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 8px 8px 35px 0px rgba(0, 0, 0, 0.45);

  animation: ${fadeIn} 0.7s ease-out;
`;
